import styled from 'styled-components';

export const CustomHeaderWrapper = styled.div`
  display: block;
`;

export const Button = styled.button`
  white-space: nowrap;
  text-align: center;
  min-width: 32px;
  background: none;
  border: 0;
`;

export const CustomHeaderTitleTemplate = styled.div`
  margin-top: 0;
  color: #000;
  font-weight: bold;
  font-size: 0.944rem;
`;
